































import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
import AnnotationModel from '@/dex-shared/models/AnnotationModel';
import KnowledgeModel from '@/dex-shared/models/KnowledgeModel';

export default Vue.extend({
  props: {
    annotation: {
      type: Object as PropType<AnnotationModel>,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      highlightedAnnotationHovered: 'highlightedAnnotationHovered',
      highlightedAnnotationClicked: 'highlightedAnnotationClicked',
    }),
    knowledge(): KnowledgeModel {
      return this.annotation
        .correctionScore()
        .correctionCriteria()
        .knowledge();
    },
    isAnyAnnotationHighlighted(): boolean {
      return (
        !!this.highlightedAnnotationHovered ||
        !!this.highlightedAnnotationClicked
      );
    },
    isHighlighted(): boolean {
      return (
        this.highlightedAnnotationHovered == this.annotation.id ||
        this.highlightedAnnotationClicked == this.annotation.id
      );
    },
    position() {
      return {
        top: `${this.annotation.coordinates.top}%`,
        left: `${this.annotation.coordinates.left}%`,
        backgroundColor: this.knowledge.color(
          this.isAnyAnnotationHighlighted ? this.isHighlighted : true,
        ),
      };
    },
    shouldShowAnnotation() {
      return (
        this.annotation.coordinates.top !== undefined &&
        this.annotation.coordinates.left !== undefined &&
        this.annotation.coordinates.height !== undefined &&
        this.annotation.coordinates.width !== undefined
      );
    },
    markingPosition() {
      const maxHeight = 100 - this.annotation.coordinates.top;
      const maxWidth = 100 - this.annotation.coordinates.left;
      const height = Math.min(this.annotation.coordinates.height, maxHeight);
      const width = Math.min(this.annotation.coordinates.width, maxWidth);
      return {
        ...this.position,
        height: `${height}%`,
        width: `${width}%`,
      };
    },
  },
});
